import React from 'react';
import {
  Box,
  Card,
  CardBody,
  Text,
  VStack,
  Button,
  HStack,
  Icon,
  useColorModeValue,
} from '@chakra-ui/react';
import { FiLogIn, FiUserPlus } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

const Login: React.FC = () => {
  const navigate = useNavigate();
  const bgColor = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.600');

  return (
    <Box 
      minH="100vh" 
      bg={useColorModeValue('gray.50', 'gray.900')} 
      display="flex" 
      alignItems="center" 
      justifyContent="center"
      p={6}
    >
      <Card bg={bgColor} borderColor={borderColor} maxW="md" w="full">
        <CardBody>
          <VStack spacing={6}>
            <VStack spacing={2}>
              <Text fontSize="2xl" fontWeight="bold">
                Tangram Interiors Vendor Portal
              </Text>
              <Text color="gray.600" textAlign="center">
                Access your vendor account or register as a new vendor partner
              </Text>
            </VStack>

            <VStack spacing={4} w="full">
              <Button
                leftIcon={<Icon as={FiLogIn} />}
                colorScheme="blue"
                size="lg"
                w="full"
                onClick={() => navigate('/dashboard')}
              >
                Sign In with Azure B2C
              </Button>

              <Text fontSize="sm" color="gray.500">
                or
              </Text>

              <Button
                leftIcon={<Icon as={FiUserPlus} />}
                variant="outline"
                colorScheme="blue"
                size="lg"
                w="full"
                onClick={() => navigate('/register')}
              >
                Register as New Vendor
              </Button>
            </VStack>

            <Text fontSize="xs" color="gray.500" textAlign="center">
              Azure B2C authentication integration coming soon
            </Text>
          </VStack>
        </CardBody>
      </Card>
    </Box>
  );
};

export default Login;

// Explicit export to ensure module compilation
export {}; 